
import { Resolve, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpServiceService } from '../services/http-service.service';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PropertiesResolver implements Resolve<any>{
  private httpService = inject(HttpServiceService);  
  
  resolve(): Observable<any> {    
    return this.httpService.getPropertyCities();
  }
};

@Injectable({
  providedIn: 'root'
})
export class PropertyStatesResolver implements Resolve<any>{
  private httpService = inject(HttpServiceService);  
  
  resolve(): Observable<any> {    
    return this.httpService.getPropertyStates();
  }
};

@Injectable({
  providedIn: 'root'
})
export class PropertyAmenities implements Resolve<any>{
  private httpService = inject(HttpServiceService);  
  
  resolve(): Observable<any> {    
    return this.httpService.getAllAmenities();
  }
};